export type Os = "windows" | "macos" | "linux" | "chromeos" | "android" | "ios" | "other";

export interface BrowserCheck {
  chromium: boolean;
  desktop: boolean;
  webusb: boolean;
  secureContext: boolean;
  os: Os;
  /** All good: Chromium, desktop, WebUSB present, https. */
  ok: boolean;
}

export function detectOs(ua: string, platform = ""): Os {
  const s = `${ua} ${platform}`;
  if (/CrOS/.test(s)) return "chromeos";
  if (/Android/.test(s)) return "android";
  if (/iPhone|iPad|iPod/.test(s)) return "ios";
  if (/Windows/.test(s)) return "windows";
  if (/Mac OS X|Macintosh/.test(s)) return "macos";
  if (/Linux|X11/.test(s)) return "linux";
  return "other";
}

export function checkBrowser(input: { ua: string; platform?: string; hasUsb: boolean; secureContext: boolean }): BrowserCheck {
  const os = detectOs(input.ua, input.platform);
  // Chromium ships "Chrome/" (Chrome, Edge, Brave, Opera, Vivaldi). Firefox/Safari never implement WebUSB.
  const chromium = /Chrome\/\d+/.test(input.ua) && !/Firefox|FxiOS/.test(input.ua);
  const desktop = os === "windows" || os === "macos" || os === "linux" || os === "chromeos";
  return { chromium, desktop, webusb: input.hasUsb, secureContext: input.secureContext, os, ok: chromium && desktop && input.hasUsb && input.secureContext };
}

/** Linux: let non-root users open Google devices in fastboot/adb. */
export const LINUX_UDEV_RULE = `# /etc/udev/rules.d/51-android.rules — Google Pixel (fastboot + adb)
SUBSYSTEM=="usb", ATTR{idVendor}=="18d1", MODE="0660", GROUP="plugdev", TAG+="uaccess"
`;

export const LINUX_UDEV_INSTALL = [
  "sudo tee /etc/udev/rules.d/51-android.rules >/dev/null <<'RULE'",
  LINUX_UDEV_RULE.trimEnd(),
  "RULE",
  "sudo udevadm control --reload-rules && sudo udevadm trigger",
].join("\n");

export const WINDOWS_DRIVER_URL = "https://developer.android.com/studio/run/win-usb";

export type DriverKey = "drivers.windows" | "drivers.linux" | "drivers.macos" | "drivers.chromeos" | "drivers.unsupported";

/** i18n key for the per-OS driver guidance block. */
export function driverGuidanceKey(os: Os): DriverKey {
  switch (os) {
    case "windows":
      return "drivers.windows";
    case "linux":
      return "drivers.linux";
    case "macos":
      return "drivers.macos";
    case "chromeos":
      return "drivers.chromeos";
    default:
      return "drivers.unsupported";
  }
}
